// View type mappings for DVC resorts
// Maps abbreviated view codes to full descriptive names

export const VIEW_MAPPINGS = {
  // Standard view types
  'S': 'Standard View',
  'V': 'Value View', 
  'I': 'Island View',
  'L': 'Lake View',
  'T': 'Theme Park View',
  'P': 'Preferred View',
  'O': 'Ocean View',
  'R': 'Resort View',
  'SV': 'Savannah View',
  'C': 'Concierge',
  
  // Premium view types
  'PV': 'Premium View',
  'LV': 'Lake View',
  'GV': 'Garden View',
  'CV': 'Courtyard View',
  'BV': 'Boardwalk View',
  'MV': 'Magic Kingdom View',
  'WV': 'Water View',
  'FV': 'Fireworks View',
  'B/P': 'Boardwalk/Preferred View',
  'TP': 'Theme Park View',
  
  // Special categories
  'Standard': 'Standard View',
  'Preferred': 'Preferred View',
  'Deluxe': 'Deluxe View'
};

// Function to get the full view name from abbreviation
export const getViewName = (viewCode) => {
  if (!viewCode) return 'Standard View';
  
  // Handle both uppercase and lowercase codes
  const normalizedCode = viewCode.toString().toUpperCase();
  
  return VIEW_MAPPINGS[normalizedCode] || `${viewCode} View`;
};

// Function to get all available view mappings
export const getAllViewMappings = () => {
  return VIEW_MAPPINGS;
};

// Function to get view options for dropdowns (sorted alphabetically)
export const getViewOptions = (availableViewCodes = []) => {
  if (availableViewCodes.length === 0) {
    // Return all mappings if no specific codes provided
    return Object.entries(VIEW_MAPPINGS)
      .map(([code, name]) => ({ code, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }
  
  // Return only the requested view codes
  return availableViewCodes
    .map(code => ({
      code,
      name: getViewName(code)
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};
